import {
  calendarDayDifference,
  formatDateOnlyWithShortMonth,
  getLabTodayDateOnly,
  parseDateOnly,
} from "../../utils/dateOnly";
import { LAB_TIME_ZONE } from "../../utils/labTime";

const INVALID_DATE_DISPLAY = "Invalid date";

const LAB_SHORT_DATE_FORMATTER = new Intl.DateTimeFormat("en-US", {
  timeZone: LAB_TIME_ZONE,
  month: "short",
  day: "numeric",
});

const LAB_DATE_FORMATTER = new Intl.DateTimeFormat("en-US", {
  timeZone: LAB_TIME_ZONE,
  year: "numeric",
  month: "short",
  day: "numeric",
});

const LAB_LONG_DATE_FORMATTER = new Intl.DateTimeFormat("en-US", {
  timeZone: LAB_TIME_ZONE,
  year: "numeric",
  month: "long",
  day: "numeric",
});

const LAB_DATE_TIME_FORMATTER = new Intl.DateTimeFormat("en-US", {
  timeZone: LAB_TIME_ZONE,
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
});

const LAB_LONG_DATE_TIME_FORMATTER = new Intl.DateTimeFormat("en-US", {
  timeZone: LAB_TIME_ZONE,
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
});

export function formatExpectedReturnDate(
  value: unknown,
  options: { omitYear?: boolean } = {}
): string {
  const dateOnly = parseDateOnly(value);
  if (!dateOnly) return INVALID_DATE_DISPLAY;
  return formatDateOnlyWithShortMonth(dateOnly, options);
}

export function formatSendOutInstantDate(
  value: string,
  options: { omitYear?: boolean } = {}
): string {
  const instant = parseInstant(value);
  if (!instant) return INVALID_DATE_DISPLAY;
  return options.omitYear
    ? LAB_SHORT_DATE_FORMATTER.format(instant)
    : LAB_DATE_FORMATTER.format(instant);
}

export function formatSendOutInstantDateTime(value: string): string {
  const instant = parseInstant(value);
  return instant
    ? LAB_DATE_TIME_FORMATTER.format(instant)
    : INVALID_DATE_DISPLAY;
}

export function formatLabCurrentDate(now: Date = new Date()): string {
  return LAB_LONG_DATE_FORMATTER.format(now);
}

export function formatLabCurrentDateTime(now: Date = new Date()): string {
  return LAB_LONG_DATE_TIME_FORMATTER.format(now);
}

export function getExpectedReturnDaysLate(
  value: unknown,
  now: Date = new Date()
): number | undefined {
  const expectedReturnDate = parseDateOnly(value);
  if (!expectedReturnDate) return undefined;
  return calendarDayDifference(expectedReturnDate, getLabTodayDateOnly(now));
}

function parseInstant(value: string): Date | undefined {
  const instant = new Date(value);
  return Number.isNaN(instant.getTime()) ? undefined : instant;
}
